export default __webpack_public_path__ + "static/media/osg_almelo_hengelo.9f558cb9.svg";